// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__3ZhvE","right":"styles_right__3QlOV"};